export default __webpack_public_path__ + "static/media/rocksdb.0b486448.svg";